import { findIndex, get, set } from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import { getAllClient } from 'src/api/client'
import { getAllShipment } from 'src/api/shipment'
export default {
  data () {
    return {
      submitting: false,
      localInvoice: {
        id: 0,
        kind: '0',
        client_id: 0,
        shipments: [],
        total_amount: 0,
        debt: 0,
        description: ''
      },
      suggettionReceiver: {},
      fetchReceiver: false,
      listReceiver: [],
      suggettionShipment: {},
      fetchShipment: false,
      listShipment: [],
      shipmentAdded: [],
      rules: {
        kind: [
          { required: true, message: 'Vui lòng chọn loại phiếu', trigger: 'change' }
        ],
        client_id: [
          { required: true, message: 'Vui lòng chọn người nhận', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('invoice', ['invoiceHelpers'])
  },
  methods: {
    ...mapActions('invoice', ['getInvoiceHelpers']),
    selectReceiver (q) {
      if (q) {
        this.fetchReceiver = true
        getAllClient({limit: 10, q: q}).then(response => {
          if (response.code === 200) {
            this.listReceiver = response.data
            this.fetchReceiver = false
          }
        })
      }
    },
    selectSuggettionReceiver () {
      this.localInvoice.client_id = this.suggettionReceiver.id
      this.listReceiver = []
    },
    selectShipment (q) {
      if (q) {
        this.fetchShipment = true
        getAllShipment({limit: 10, q: q, include: 'receiver,picker', client_id: this.localInvoice.client_id}).then(response => {
          if (response.code === 200) {
            this.listShipment = response.data
            this.fetchShipment = false
          }
        })
      }
    },
    selectSuggettionShipment () {
      if (this.localInvoice.shipments.indexOf(this.suggettionShipment.id) < 0) {
        this.localInvoice.shipments.push(this.suggettionShipment.id)
        this.shipmentAdded.push(this.suggettionShipment)
      }
      this.listShipment = []
    },
    removeShipment (shipment) {
      let index = findIndex(this.shipmentAdded, shipment)
      let sindex = this.localInvoice.shipments.indexOf(shipment.id)
      this.shipmentAdded.splice(index, 1)
      this.localInvoice.shipments.splice(sindex, 1)
    },
    removeZero (key) {
      if (parseInt(get(this.localInvoice, key)) === 0) {
        set(this.localInvoice, key, '')
      }
    },
    addZero (key) {
      if (get(this.localInvoice, key) === '') {
        set(this.localInvoice, key, 0)
      }
    },
    newInvoice () {
      this.localInvoice = {
        id: 0,
        kind: '0',
        client_id: 0,
        shipments: [],
        total_amount: 0,
        debt: 0,
        description: ''
      }
    }
  },
  mounted () {
    this.newInvoice()
    if (!Object.keys(this.invoiceHelpers).length) {
      this.getInvoiceHelpers()
    }
  },
  watch: {
    localInvoice: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/mixins/index.js